<template>
  <div class="login">
    <!-- 左侧图片 -->
    <div class="imgpart">
      <el-image class="leftImg" :src="loginBg" fit="fill" lazy></el-image>
    </div>
    <!-- 右侧登录 -->
    <!-- <%--登陆注册模块--%> -->
    <div class="loginForm">
      <!-- //FIXME: 发布时要打开 -->
      <div class="logoImgWrap">
        <img class="logoImg" src="../assets/images/index/logoicon.png" width="303" height="140"/>
      </div>
      <div style="clear: both;"></div>
      <!-- <%--短信验证登录--%> -->
      <div class="contentpart" id="box_1" v-show="boxshow">
        <el-form
          :model="formMsg"
          :rules="rules"
          ref="formMsg"
          label-width="100px"
          class="formMsgClass"
          @keyup.enter.native="userLogin('formMsg')"
        >
          <div class="userPanel">
            <el-form-item label prop="phone" id="phoneTitle">
              <img src="../assets/images/index/icon_login_phone.png" />
              <el-input v-model="formMsg.phone" id="phone" placeholder="请输入用户名" />
            </el-form-item>
          </div>
          <div class="userPanel">
            <el-form-item label prop="msgCode" id="phoneMsg">
              <img src="../assets/images/index/icon_login_pwd.png" />
              <el-input
                v-model="formMsg.msgCode"
                id="msgCode"
                placeholder="请输入短信验证码"
                @focus="btnColor"
              ></el-input>
              <input
                class="phoneBtn"
                id="timebtn"
                type="button"
                :value="codeMsg"
                :disabled="getMsgShow"
                :class="{'on':getMsgShow}"
                @click="sendemail"
              />
            </el-form-item>
          </div>
          <div id="clearpart" style="clear:both;height: 0px"></div>
        </el-form>
      </div>
      <!-- 密码验证登录--%> -->
      <div id="box_2" class="contentpart" v-show="!boxshow">
        <el-form
          :model="formUser"
          :rules="rules"
          ref="formUser"
          label-width="100px"
          class="formUserClass"
          @keyup.enter.native="userLogin('formUser')"
        >
          <div class="userPanel">
            <el-form-item label prop="userName" id="phoneTitle">
              <img src="../assets/images/index/icon_login_user.png" />
              <el-input
                v-model="formUser.userName"
                id="userName"
                placeholder="请输入用户名"
                style="display:inline"
              />
            </el-form-item>
          </div>
          <div class="userPanel">
            <el-form-item label prop="password" id="phoneTitle">
              <img src="../assets/images/index/icon_login_pwd.png" />
              <el-input
                v-model="formUser.password"
                id="password"
                placeholder="请输入登录密码"
                style="text-align: left;"
                type="password"
              ></el-input>
            </el-form-item>
          </div>
          <div id="clearpart" style="clear:both;height: 0px"></div>
        </el-form>

        <div id="clearpart" style="clear:both;height: 0px"></div>
      </div>

      <!-- <div class="titlepart">
        <button v-if="!boxshow" style="padding-left:0" type="button" id="clickPasswordLogin" @click="setclick1()">
          <p id="changefont2" style="cursor: pointer;color:#079DBD;">手机快捷登录</p>
        </button>
        <button v-if="boxshow" style="padding-left:0" type="button" id="clickPasswordLogin" @click="setclick2()">
          <p id="changefont2" style="cursor: pointer;color:#079DBD;">账号密码登录</p>
        </button>
      </div>-->
      <el-row>
        <el-col :span="12" style="text-align:left;">
          <el-button
            v-show="!boxshow"
            class="loginBtn"
            id="login"
            type="primary"
            @click="userLogin('formUser')"
            :disabled="!setlogin&&boxshow"
            ref="psdCodeLogin"
          >登录</el-button>
          <el-button
            v-show="boxshow"
            class="loginBtn"
            id="login1"
            type="primary"
            :disabled="!setlogin&&!boxshow"
            @click="userLogin('formMsg')"
            ref="msgCodeLogin"
          >登录</el-button>
        </el-col>
        <el-col :span="12" style="text-align:right;">
          <el-button
            class="resetBtn"
            id="login1"
            type="info"
            @click="resetClick"
            ref="msgCodeLogin"
          >重置</el-button>
        </el-col>
      </el-row>
    </div>
    <div style="clear: both"></div>
    <div class="verifyShow">
      <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备13029610号-2</a>
    </div>
  </div>
 
</template>

<script>
import Vue from "vue";
import home from "../components/home.vue";

import {
  getUserInfoService,
  getCheckStatusService,
  getUserAuthorityService,
  getMsgCodeService,
  loginByPropertyMsgCodeRSAService,
  getRsaPublicKey,
  getverificationUrl
} from "../services/loginService";
import loginBg from "../assets/images/index/loginbg.png"
export default {
  name: "login",
  data() {
    var checkMsgcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("验证码为数字值"));
        }
      }, 1000);
    };
    return {
      loginBg:loginBg,
      formMsg: {
        phone: "",
        msgCode: ""
      },
      formUser: {
        userName: "",
        password: ""
      },
      boxshow: false, //true:短信验证码登录，false:用户名密码登录
      istrue: false,
      time: 60, //短信验证码发送时间
      getMsgShow: false,
      codeMsg: "获取验证码",
      verificationUrl: "",
      uuid: "",
      setlogin: false, //登录按钮颜色控制，是否触发相应按钮focus时间
      checked: false, //用户协议是否勾选
      sendflag: true,
      publicKey: "", //公钥
      rsaPassWord: "",
      rules: {
        phone: [
          { required: true, message: "请输入注册的手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号位数不正确", trigger: "blur" }
        ],
        msgCode: [
          { required: true, message: "请输入验证码", trigger: "change" }
        ],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
          { min: 3, max: 15, message: "请输入3到15位密码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    setclick1() {
      this.boxshow = true;
      this.setlogin = false;
      this.checked = false;
      var PHONE = this.formMsg.phone;
      if (PHONE == "" || null == PHONE) {
        return;
      }
      //验证手机号
      var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/;
      if (PHONE.length != 11 || !reg.test(PHONE)) {
        return;
      }
      this.setlogin = true;
    },
    setclick2() {
      this.boxshow = false;
      this.setlogin = false;
      this.getPicMessage();
      var PHONE = this.formUser.userName;
      if (PHONE == "" || null == PHONE) {
        return;
      }
      //验证手机号
      var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/;
      if (PHONE.length != 11 || !reg.test(PHONE)) {
        return;
      }
      this.setlogin = true;
    },
    // addclass(i) {
    //   switch (i) {
    //     case 0:
    //       return "skinA";
    //     case 1:
    //       return "changefont1";
    //     case 2:
    //       return "changefont2";
    //   }
    // },
    btnColor() {
      let localuserName = localStorage.getItem("localuserName"); //获取用户名，二次登陆勾选用户协议
      //变换登录按钮背景色
      if (this.boxshow) {
        var PHONE = this.formMsg.phone;
        if (PHONE == "" || null == PHONE) {
          // this.$alert("请输入手机号", "错误", {
          //   confirmButtonText: "确定"
          // });
          return;
        }
        //验证手机号
        var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/;
        if (PHONE.length != 11 || !reg.test(PHONE)) {
          // this.$alert("请输入正确的手机号", "错误", {    //造成死循环
          //   confirmButtonText: "确定"
          // });

          return;
        }

        if (
          localuserName != "" &&
          null != localuserName &&
          undefined != localuserName
        ) {
          if (localuserName.trim() == PHONE) {
            this.checked = true;
          }
        }
        this.setlogin = true;
      } else {
        let PHONE = this.formUser.userName;
        if (PHONE == "" || null == PHONE) {
          // this.$alert("请输入手机号", "错误", {
          //   confirmButtonText: "确定"
          // });
          return;
        }
        //验证手机号

        let reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/;
        if (PHONE.length != 11 || !reg.test(PHONE)) {
          //  this.$confirm("请输入正确手机号").then(() => {
          //         // this.boxshow = true;
          //         // this.$router.replace({ name: "login" })
          //       });
          // this.$alert("请输入正确手机号", "错误", {
          //   confirmButtonText: "确定"
          // });
          return;
        }
        if (
          localuserName != "" &&
          null != localuserName &&
          undefined != localuserName
        ) {
          if (localuserName.trim() == PHONE) {
            this.checked = true;
          }
        }
        this.setlogin = true;
      }
    },
    sendemail() {
      var PHONE = this.formMsg.phone;
      if (PHONE == "" || null == PHONE) {
        this.$alert("请输入手机号", "提示");
        return;
      }
      //验证手机号
      var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/;
      if (PHONE.length != 11 || !reg.test(PHONE)) {
        this.$alert("请输入正确的手机号", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      // this.$refs[formName].validate(valid => {
      //   if (valid) {
      //     //如果通过验证 to do...
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
      this.time = 60;
      this.settime();
      this.getMsgShow = true;
      getRsaPublicKey()
        .then(res => {
          this.publicKey = res.data.publicKey;
          let basePassWord = btoa(this.formUser.password);
          console.log(basePassWord);
          let rsaInfo = PHONE + ",00";
          let rsaVerfyCode = this.$getRSASign(rsaInfo, this.publicKey);
          return getMsgCodeService(rsaVerfyCode);
        })
        .then(result => {})
        .catch({});
    },
    settime() {
      var timer = setInterval(() => {
        if (this.time == 0) {
          clearInterval(timer);
          this.codeMsg = "获取短信验证码";
          this.getMsgShow = false;
        } else {
          this.codeMsg = "重新发送" + this.time + "秒";
          this.time--;
        }
      }, 1000);
    },
    resetClick() {
      if (this.boxshow) {
        this.$refs.formMsg.resetFields();
      } else {
        this.$refs.formUser.resetFields();
      }
    },
    userLogin(formUser) {
      if (this.boxshow) {
        var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/;
        this.$refs[formUser].validate(valid => {
          if (valid) {
            this.msgLogin();
          }
        });
      } else {
        this.$refs[formUser].validate(valid => {
          let { userName, password } = this.formUser;
          // var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(16[0-9]{1}))+\d{8})$/;
          // if (!valid) {
          //   return false;
          // }
          let user = {};
          user.name = userName;
          user.password = password;
          getUserInfoService(user)
            .then(result => {
              if (10000000 == result.code) {
                //登录成功
                console.log('登录成功,登录成功,登录成功')
                Vue.prototype.$loginIng = true;
                sessionStorage.setItem("currentUserId", result.data.id); //存储用户信息
                sessionStorage.setItem("name", result.data.displayName); //存储员工姓名
                sessionStorage.setItem("deptId", result.data.deptId); //存储部门
                sessionStorage.setItem("orgId", result.data.orgId); //存储用户组织
                sessionStorage.setItem("orgName", result.data.orgName); //存储用户组织
                sessionStorage.setItem("accessToken", result.data.token); //存储accessToken
                sessionStorage.setItem("refreshTokenFlag",1);
                sessionStorage.setItem('login-name', result.data.name);
                sessionStorage.setItem('supplierId', result.data.supplierId);  //判断是否为供应商用户
                sessionStorage.setItem('isZongheban', result.data.isZongheban);  //判断是否为综合办
                this.$router.push({ name: "home" });
              } else if (result.code >= 20000000) {
                this.$alert(result.msg, "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定"
                });
              }
            })
            .catch(error => {
              this.$alert(error || "系统异常", "错误", {
                confirmButtonText: "确定"
              });
            });
        });
      }
    },
    msgLogin() {
      let { phone, msgCode } = this.formMsg;
      getRsaPublicKey()
        .then(res => {
          this.publicKey = res.data.publicKey;
          let rsaInfo = phone + "," + msgCode + ",00";
          this.rsaPassWord = this.$getRSASign(rsaInfo, this.publicKey);
          return loginByPropertyMsgCodeRSAService(this.rsaPassWord);
        })
        .then(result => {
          //登录成功
          if (0 == result.resultCode) {
            Vue.prototype.$loginIng = true;
            sessionStorage.setItem("userCode", result.data.userCode); //存储用户信息
            sessionStorage.setItem("userName", result.data.phone); //存储用户名
            sessionStorage.setItem("roleCode", result.data.roleCode); //存储用户角色
            sessionStorage.setItem("deptCode", result.data.deptCode); //存储用户组织
            sessionStorage.setItem("operationFlag", result.data.operationFlag); //存储用户分类
            sessionStorage.setItem("accessToken", result.data.accessToken); //存储token
            sessionStorage.setItem("refreshToken", result.data.refreshToken); //存储refreshToken
            this.$router.push({ name: "home" });
          } else {
            this.$message.error(result.msg ? result.msg : "登录失败，请重试");
          }
        })
        .catch(error => {
          this.$alert(error || "系统异常", "提示");
        });
    },
    secondLoginProtocol(newVal) {
      if (
        null != localStorage.getItem("localuserName") &&
        "" != localStorage.getItem("localuserName") &&
        undefined != localStorage.getItem("localuserName")
      ) {
        let localuserName = localStorage.getItem("localuserName"); //获取用户名，二次登陆勾选用户协议

        if (localuserName.trim() == newVal.trim()) {
          this.checked = true;
          this.btnColor();
        }
      }
    },
    getPubKey() {
      //获取公钥
      getRsaPublicKey()
        .then(res => {
          this.publicKey = res.data.publicKey;
        })
        .catch(error => {
          this.$alert(error || "系统异常", "错误", {
            confirmButtonText: "确定"
          });
          // this.isLoading = false;
        });
    },
    getPicMessage() {
      //获取验证码
      this.uuid = "cms" + this.guid();
      this.verificationUrl = getverificationUrl() + "?uuid=" + this.uuid;
    },
    //用于生成uuid
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    guid() {
      return (
        this.S4() +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        this.S4() +
        this.S4()
      );
    },
  },

  created() {
    var _this = this;
    // document.onkeydown = function(e) {
    //   let key = window.event.keyCode;
    //   if (key == 13) {
    //     if (_this.boxshow) {
    //       if (
    //         (null == _this.formMsg.msgCode || "" == _this.formMsg.msgCode) &&
    //         _this.sendflag
    //       ) {
    //         _this.sendflag = false;
    //         // _this.$refs.msgCodeLogin.click()
    //         _this.sendemail();
    //       }
    //       if (null != _this.formMsg.msgCode && "" != _this.formMsg.msgCode) {
    //         // _this.userLogin(_this.formMsg);
    //         _this.$refs.msgCodeLogin.click()
    //       }
    //     } else {
    //        _this.userLogin('formUser');
    //        console.log()
    //       //_this.$refs.psdCodeLogin.dispatchEvent(new MouseEvent('click'))

    //     }
    //   }
    // };
  },
  mounted() {
    //  this.getPubKey();
  },
  computed: {
    getUserName: function() {
      return this.formUser.userName;
    },
    getPhone: function() {
      return this.formMsg.phone;
    }
  },
  watch: {
    getPhone: function(newVal) {
      this.secondLoginProtocol(newVal);
    },
    getUserName: function(newVal) {
      this.secondLoginProtocol(newVal);
    },
    deep: true
  }
};
</script>

<style scoped lang="scss">
.login {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;
  display: flex;
}
.userPanel {
  /* height: 60px;
  line-height: 60px; */
  border: 1px solid #069dbc;
  box-shadow: 2px 3px 20px 0 rgba(46, 135, 153, 0.2);
  border-radius: 2px;
  margin: 5% 0%;
  img {
    vertical-align: middle;
  }
  .el-input {
    margin-left: 16px;
    vertical-align: middle;
  }
}
.title {
  margin: 80px auto 80px 310px;
  height: 48px;
  width: 270px;
}
.title span {
  font-size: 28px;
  color: #3a3a3a;
  letter-spacing: -0.08px;
  padding-top: 8px;
  float: right;
}

/* 左侧图片整体 */
.imgpart {
  height: 100%;
  width: 62.5%;
  text-align: left;
  .leftImg{
    height: 100%;
    width: 100%;
  }

}

/* 右侧登录整体 */
.loginForm {
  width: 27.5%;
  height: 100%;
  padding: 0 5%;
  // float: left;
  // margin: 54px 32px 30px 310px;
  /* box-shadow: -2px -3px 5px #e0e0e0; */
  background: #ffffff;
  .logoImgWrap{
    /*height: calc(100% - 600px);*/
    height: 30%;
    vertical-align: middle;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 80px;
    .signBtn{
      position: fixed;
      bottom: 20px;
      left: 0;
      opacity: 0.1;
    }
  }
  .logoImg {
    /*height: 1080;*/
    /*width: 1200;*/
    /*padding: 20% 0;*/
    /*padding-top: 40%;*/
  }
  /* box-shadow: 0 0 8px 0 rgba(204, 204, 204, 0.5); */
  /* border-radius: 2px; */
}
.titlepart {
  margin: 0 5% 2% 0;
  font-size: 18px;
  color: #858585;
  letter-spacing: -0.05px;
  text-align: left;
}
.titlepart button {
  border: none;
  background: #ffffff;
  font-size: 18px;
  outline: none;
}
.mianpart {
  margin-top: 30px;
}
.contentpart input[type="text"] {
  border: none;
  outline: none;
  width: 74%;
  font-size: 16px;
  height: 40px;
  float: bottom;
  margin-top: 30px;
}
.loginBtn {
  width: 90%;
  height: 60px;
  background: #079dbd;
  border-radius: 2px;
  color: #fff;
  font-size: 18px;
  letter-spacing: -0.05px;
  margin-left: 0;
}
.resetBtn {
  width: 90%;
  height: 60px;
  background: #fff;
  border: 1px solid #079dbd;
  border-radius: 2px;
  color: #079dbd;
  font-size: 18px;
  letter-spacing: -0.05px;
  margin-left: 10%;
}
.agreeCheck {
  margin: 0 48px;
  text-align: left;
}
.agreeCheck span {
  font-size: 16px;
  color: #858585;
  letter-spacing: -0.05px;
  line-height: 22px;
}
.protocol {
  font-size: 16px;
  color: #858585;
  letter-spacing: -0.05px;
  line-height: 22px;
}
.agreeCheck {
  font-size: 16px;
  color: rgb(7, 157, 189);
  letter-spacing: -0.05px;
  line-height: 22px;
  cursor: pointer;
}
.phoneBtn {
  border: none;
  color: rgb(7, 157, 189);
  font-size: 16px;
  letter-spacing: -0.05px;
  cursor: pointer;
  background: none;
  margin-top: 10px;
  float: right;
}
.phoneBtn1 {
  border: none;
  color: rgb(7, 157, 189);
  font-size: 16px;
  letter-spacing: -0.05px;
  cursor: pointer;
  background: none;
}
.loginForm .whrite {
  display: inline-block;
  margin-bottom: 8px;
  margin-left: 10px;
  width: 200px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  padding-left: 10px;
  outline: none;
}

.loginForm .houer {
  margin-left: 152px;
  width: 150px;
}
.loginForm .button {
  margin-top: 10px;
  width: 112px;
  height: 35px;
  background: #00c8d0;
  font-size: 16px;
  color: #fff;
  padding: 0;
  border: 0;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 195px;
}
.agreeCheck input[type="checkbox"] {
  width: 18px;
  vertical-align: middle;
  margin-right: 8px;
}
.blackfont {
  font-weight: bold;
}
.addcolor {
  background-image: linear-gradient(-135deg, rgb(7, 157, 189) 0%, #2bb1ff 100%);
  border-radius: 2px;
  color: #ffffff;
}
.phoneBtn.on {
  color: #ccc;
  cursor: not-allowed;
}
.right a {
  color: #f00;
}
</style>

<style>
.login #msgCode {
  border: none;
  outline: none;
  width: 50%;
  font-size: 16px;
  height: 40px;
  float: bottom;
  margin-left: 0px;
  padding-left: 0px;
}

.login #phone {
  border: none;
  outline: none;
  width: 50%;
  font-size: 16px;
  height: 40px;
  float: bottom;
}

.login #box1_msg {
  height: 75px;
  margin: auto 48px;
}
.login #userName {
  border: none;
  outline: none;
  width: 50%;
  font-size: 16px;
  height: 40px;
  float: bottom;
  /* margin-top: 10px; */
  margin-left: 0px;
}
.login #password {
  border: none;
  outline: none;
  width: 50%;
  font-size: 16px;
  height: 40px;
  float: bottom;
}
.login .el-form-item__label {
  line-height: 40px;
  font-size: 18px;
  text-align: left;
  padding: 28px 12px 0 0;
}
.login .el-form-item {
  margin-bottom: 0px;
}
.login .el-form-item__content {
  margin-left: 0px !important;
  text-align: left;
  vertical-align: middle;
  padding: 10px;
}
.login .el-input {
  position: relative;
  font-size: 14px;
  display: inline;
}
.login .el-input__inner {
  padding: 0;
}
.login .el-checkbox__input.is-checked .el-checkbox__inner,
.login .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: rgb(7, 157, 189);
  border-color: rgb(7, 157, 189);
}
.login .el-checkbox__inner {
  border: 1px solid #858585;
}
.login .verifyShow {
  position: absolute;
  right: 5%;
  bottom: 20px;
}
.login .verifyShow a {
  color: #858585;
}
</style>

